import React, { useState, useEffect } from "react";
import Navbar from "../../../Components/Navbar";
import { useNavigate, redirect } from "react-router-dom";
import { useAuthContext } from "../../../hooks";
import { getAllEmployeeDetails } from "../../../api/HRDashboard/getAllEmployeeDetails";
import AdminLeaveSc from "../index.sc";
function Index() {
  const navigate = useNavigate();
  const auth = useAuthContext();
  const [allDetails, setAllDetails] = useState<any>([]);
  const fetchAllEmployeeDetails = async () => {
    await getAllEmployeeDetails(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setAllDetails(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllEmployeeDetails();
  }, []);

  return (
    <AdminLeaveSc>
      <div className="admin-leave-conatiner">
        <div className="employee-list-container">
          <div className="profile-list">Profile</div>
        </div>
        {allDetails?.map((data: any) => {
          return (
            <>
              <div
                className="employee-list-containers"
                onClick={() => navigate(`${data?.employee_id}`)}
              >
                <div className="profile-list ">
                  <div className="employee-name mx-2 w-100">{data?.Name}</div>
                </div>

                <div className="leave-details-mains" style={{ padding: "4px" }}>
                  View Employee Details
                </div>
              </div>
            </>
          );
        })}
      </div>
    </AdminLeaveSc>
  );
}

export default Index;
